import React from "react";
const CancelRequestForm = (props) => {
    const { msg, className = "",onClick="" } = props;
    const handelOnClick = () => {
        onClick ? onClick(false) : "";
    }
    return (
        <div className="alert cancel-request-form" onClick={handelOnClick}>
            <div
                className={`confirmation ${className}`}
                onClick={(e) => e.stopPropagation()}
                style={{ background: '#fff', paddingBottom: '16px' }}
            >
                <div
                    className="alert--content success"
                    style={{ width: "100%", padding: "16px", background: '#fff' }}
                >
                    {msg}
                </div>
            </div>
        </div>
    );
};

export default CancelRequestForm;